<!-- Breadcrumbs -->
<ng-container *ngIf="!this.link; else withLink">
  <app-breadcrumbs
    [segments]="[{ label: breadcrumbLabelDetails, routerLink: '/dettaglio' }]"
  ></app-breadcrumbs>
</ng-container>
<ng-template #withLink>
  <app-breadcrumbs
    [segments]="[
      { label: breadcrumbLabelResult, routerLink: link },
      { label: breadcrumbLabelDetails, routerLink: '/dettaglio' }
    ]"
  ></app-breadcrumbs>
</ng-template>
<!-- Fine Breadcrumbs -->

<div class="container" *ngIf="farmaco$ | async as response"  >
  <div class="details-main" >
  <!-- Nome Farmaco e Azienda -->

  <div class="row text-black mb-3" >
    <div class="col-sm-12 mb-3">
      <h1 class="text-primary h3">
        {{
        response.data.medicinale.denominazioneMedicinale +
        " " +
        response.data.descrizioneFormaDosaggio
        }}
      </h1>
    </div>
    <div class="col-12 mb-3">
      <div *ngIf="response.data.medicinale.aziendaTitolare">
        <h2 class="h5 fw-normal">
          <span
            class="fw-bold"
            i18n="
              testo azienda titolare|Pagina dettaglio
              medicinali@@details-page.title-text-azienda-titolare"
          >Azienda titolare:</span
          >
          {{ response.data.medicinale.aziendaTitolare }}
        </h2>
      </div>
    </div>
  </div>
  <!-- Fine Nome farmaco e Azienda -->

  <!-- Contenuto principale -->
  <div class="row mb-3">
    <div class="col-sm-12 col-lg-8 text-black">
      <div class="container">
        <!-- Download link -->
        <div class="row mb-5">
          <div class="col-sm-6 mb-2">
            <ng-container
              *ngIf="
                response.data.tipoAutorizzazione !== 'P';
                else buttonTemplate
              "
            >
              <a
                class="btn btn-link p-0"
                [routerLink]="[
                  '/organizzazione',
                  response.data.medicinale.codiceSis,
                  'farmaci',
                  response.data.medicinale.aic6,
                  'stampati',
                  'FI'
                ]"
                [routerLinkActive]="['disabled']"
                (click)="getFile(response.data, 'FI')"
                [class.disabled]="!response.data.flagFI"
              >
                <svg
                  [ngClass]="
                    response.data.flagFI
                      ? 'icon icon-primary me-2'
                      : 'icon icon-secondary me-2'
                  "
                >
                  <use href="assets/icons/ic_foglietto.svg#ic_foglietto"></use>
                </svg>
                <span
                  class="small fw-bold text-decoration-underline"
                  i18n="
                    Testo download foglietto illustrativo|Dettaglio forma e
                    dosaggio
                  "
                >
                  Foglio Illustrativo
                </span>
              </a>
            </ng-container>
            <ng-template #buttonTemplate>
              <button
                class="btn btn-link p-0"
                [disabled]="!response.data.flagFI"
                (click)="getFile(response.data, 'FI')"
              >
                <svg class="icon icon-primary me-2">
                  <use href="assets/icons/ic_foglietto.svg#ic_foglietto"></use>
                </svg>
                <span
                  class="small fw-bold text-decoration-underline"
                  i18n="
                    Testo download foglietto illustrativo|Dettaglio forma e
                    dosaggio@@details-page.download-text-FI"
                >Foglio Illustrativo</span
                >
              </button>
            </ng-template>
          </div>

          <!-- Riassunto Caratteristi Prodotto -->
          <div class="col-sm-6">
            <button
              class="btn btn-link p-0"
              (click)="getFile(response.data, 'RCP')"
              [disabled]="!response.data.flagRCP"
            >
              <svg [ngClass]="response.data.flagRCP
                ? 'icon icon-primary me-2'
                : 'icon icon-secondary me-2'
                ">
                <use
                  href="assets/icons/ic_caratteristiche.svg#ic_caratteristiche"
                ></use>
              </svg>
              <span
                class="small fw-bold text-decoration-underline"
                i18n="Testo download RCP|Dettaglio forma e dosaggio"
              >Riassunto Caratteristiche Prodotto</span
              >
            </button>
          </div>
          <!-- Riassunto Caratteristi Prodotto -->
        </div>
        <!-- Fine download link -->

        <!-- Informazioni farmaco -->
        <div class="row mb-5">
          <div class="col-sm-6 mb-3">
            <span
              i18n="testo principi attivi|Pagina dettaglio medicinali"
              class="h6"
            >Principi Attivi</span
            >
            <ul class="">
              <li
                class="text-black small"
                *ngFor="let pa of response.data?.principiAttiviIt"
              >
                {{ pa }}
              </li>
            </ul>
            <p *ngIf="!response.data?.principiAttiviIt"></p>
          </div>
          <div class="col-sm-6 mb-3">
            <span
              class="h6"
              i18n="testo vie di somministrazione|Pagina dettaglio medicinali"
            >Vie di somministrazione</span
            >
            <ul class="">
              <li
                class="text-black small"
                *ngFor="let vs of response.data.vieSomministrazione"
              >
                {{ vs }}
              </li>
            </ul>
            <p *ngIf="!response.data?.vieSomministrazione"></p>
          </div>
          <div class="col-sm-6 mb-3">
            <span class="h6" i18n="testo codici atc|Pagina dettaglio medicinali"
            >ATC</span
            >
            <ul class="">
              <li
                class="text-black small"
                *ngFor="let codiceAtc of response.data.codiceAtc; let i = index"
              >
                {{ codiceAtc }} - {{ response.data.descrizioneAtc[i] }}
              </li>
            </ul>
          </div>
          <div class="col-sm-6 mb-3">
            <div *ngIf="response.data.formaFarmaceutica">
              <span
                class="h6"
                i18n="titolo forma farmaceutica|Pagina dettaglio medicinali"
              >Forma farmaceutica</span
              >
              <p class="small mb-0">
                {{ response.data.formaFarmaceutica }}
              </p>
            </div>
          </div>
        </div>
        <!-- Fine informazioni farmaco -->
      </div>
    </div>

    <div class="col-sm-12 col-lg-4">
      <!-- Informazioni con icona -->
      <div class="row">
     

       <!--  <div
          class="details-custom"
          *ngIf="response.data.innovativo || response.data.orfano"
        >
          Farmaco innovativo 
          <div class="col-sm-12 p-2" *ngIf="response.data.innovativo">
            <div class="d-flex">
              <img
                class="me-3 icons-medicinale"
                src="assets/icons/innovativo.svg"
                alt
              />
              <span
                class="link-download"
                i18n-aria-label="
                  Dicitura per Farmaco innovativo|Icone dettaglio medicinale
                "
                i18n="
                  Dicitura per Farmaco innovativo|Icone dettaglio medicinale
                "
                aria-label="Farmaco innovativo"
              >Farmaco Innovativo</span
              >
            </div>
          </div>
          Fine Farmaco innovativo -->

          <!-- Farmaco Orfano 
          <div class="col-sm-12 p-2" *ngIf="response.data.orfano">
            <div class="d-flex">
              <img
                class="me-3 icons-medicinale"
                alt
                src="assets/icons/orfano.svg"
              /><span
              class="link-download"
              i18n-aria-label="
                  Dicitura per Farmaco orfano|Icone dettaglio medicinale
                "
              i18n="Dicitura per Farmaco orfano|Icone dettaglio medicinale"
              aria-label="Farmaco orfano"
            >Farmaco Orfano</span
            >
            </div>
          </div>
          Fine  Farmaco Orfano
        </div> -->

        <div 
          class="col-sm-12 mb-2 rischi"
          *ngIf="
            response.data.flagDopante ||
            response.data.flagAlcol ||
            response.data.flagGuida ||
            response.data.flagPotassio
          "
        >
          <h4
            class="h6 text-black mt-3 text-center"
            i18n="
              details-page|title-text-rischi@@details-page.title-text-rischi"
          >
            Rischi
          </h4>
        

        <!-- Sostanza dopante  -->
        <div class="col-sm-12 mb-3" *ngIf="response.data.flagDopante">
          <div class="d-flex">
            <img
              class="me-3 icons-medicinale"
              src="assets/images/signDoping.png"
              alt
            /><span
            class="link-download"
            i18n-aria-label="
                Dicitura per Contiene sostanza dopante|Icone dettaglio
                medicinale
              "
            i18n="
                Dicitura per Contiene sostanza dopante|Icone dettaglio
                medicinale
              "
            aria-label="Contiene sostanza dopante"
          >Contiene Sostanza Dopante</span
          >
          </div>
        </div>
        <!--Fine Sostanza dopante  -->

        <!-- Contiene alcol  -->
        <div class="col-sm-12 mb-3" *ngIf="response.data.flagAlcol">
          <div class="d-flex">
            <img
              class="me-3 icons-medicinale"
              src="assets/images/ic_alcool.png"
              alt
            />
            <span
              class="link-download"
              i18n-aria-label="
                Dicitura per Sostanza Contenente Alcol|Icone dettaglio
                medicinale
              "
              i18n="
                Dicitura per Sostanza Contenente Alcol|Icone dettaglio
                medicinale
              "
              aria-label="Non assumere contemporaneamente bevande alcoliche"
            >Non assumere contemporaneamente bevande alcoliche</span
            >
          </div>
        </div>
        <!-- Fine Contiene alcol  -->

        <!-- Rischio alla guida  -->
        <div class="col-sm-12 mb-3" *ngIf="response.data.flagGuida">
          <div class="d-flex">
            <img
              class="me-3 icons-medicinale"
              src="assets/images/signLevel{{ '3' }}@2x.png"
              alt
            /><span
            class="link-download"
            i18n-aria-label="Rischio alla guida (livello 3)"
            i18n="Rischio alla guida (livello 3)"
            aria-label="Rischio alla guida (livello 3)"
          >Rischio alla guida (livello 3)</span
          >
          </div>
        </div>
        <!-- Fine Rischio alla guida  -->

        <!-- Potassio -->
        <div class="col-sm-12 mb-3" *ngIf="response.data.flagPotassio">
          <div class="d-flex">
            <img
              class="me-3 icons-medicinale"
              alt
              src="assets/images/potassio.png"
            /><span
            class="link-download"
            i18n-aria-label="
                Dicitura per Sostanza Contenente Potassio|Icone dettaglio
                medicinale
              "
            i18n="
                Dicitura per Sostanza Contenente Potassio|Icone dettaglio
                medicinale
              "
            aria-label="Potassio (k), diluire prima della somministrazione: mortale se infuso non diluito"
          >Potassio (k), diluire prima della somministrazione: mortale se
              infuso non diluito</span
          >
          </div>
        </div>
        <!-- Fine Potassio -->
      </div>
      </div>
      <!-- Fine informazioni icona -->
    </div>
  </div>
  <div class="row mb-2">
    <!-- Badges -->
    <div class="badge-container">
      <!-- In Carenza -->
      
      
      <!-- Fine In carenza -->

      <!-- Orfano -->
      <div class="badge rounded-pill bg-info text-black" *ngIf="response.data.orfano">
        <img
                style="height: auto;"
                src="assets/icons/innovativo-black.svg"
                alt
              />
      <span
      i18n=" Dicitura per Farmaco orfano|badge dettaglio dettaglio@@dettaglio.text-orfano"
      i18n-aria-label="Dicitura per Farmaco orfano|Icone dettaglio medicinale"
      style="padding:5px"
      >ORFANO</span>
    </div>
      <!-- Fine Orfano -->

      <!-- innovativo -->
    <div class="badge rounded-pill bg-info text-black" *ngIf="response.data.innovativo">
      <img
                style="height: auto;"
                src="assets/icons/innovativo-black.svg"
                alt
              />
      <span
        i18n=" Dicitura per Farmaco innovativo|badge dettaglio dettaglio@@dettaglio.text-innovativo"
        i18n-aria-label="Dicitura per Farmaco innovativo|Icone dettaglio medicinale"
        style="padding:5px"
        >INNOVATIVO</span
      >
    </div>
      <!-- Fine Innovativo -->
    </div>
    <!-- Fine Badges -->
  </div>
  <!-- Fine Contenuto Principale -->
</div>
  <!-- Confezioni -->
  <div class="row g-4 mb-3">
    <div class="col-12">
      <h3
        class="text-primary h4"
        i18n="
          details-page| title-confezioni@@details-page.title-text-condezioni"
      >
        Confezioni
      </h3>
    </div>
    <div
      class="row g-4 mb-3"
      [class.scrollable-row]="response.data.confezioni.length > 2"
    >
      <app-confezione
        *ngFor="let confezione of response.data.confezioni"
        [confezione]="confezione"
        class="col-sm-12 col-lg-6"
      ></app-confezione>
    </div>
  </div>
  <!-- Fine Confezioni -->

  <!-- Modale importazione parallela -->
  <modal [modalConfig]="parallelImportModalConfig" #modal>
    <div class="container">

      <button
        class="btn btn-link p-0 mb-3"
        (click)="
          getFileModal(
            response.data.sisImportazioneParallela,
            response.data.aic6ImportazioneParallela
          )
        "
      >
        <svg class="icon icon-primary me-2">
          <use
            href="assets/icons/ic_foglietto.svg#ic_foglietto"
            xlink:href="assets/icons/ic_foglietto.svg#ic_foglietto"
          ></use>
        </svg>
        <span
          *ngIf="type === 'FI'"
          class="small fw-bold text-decoration-underline"
          i18n="
            Testo download foglietto illustrativo|Dettaglio forma e
            dosaggio@@details-page.download-text-FI"
        >Foglio Illustrativo</span
        >
        <span
          *ngIf="type === 'RCP'"
          class="small fw-bold text-decoration-underline"
          i18n="Testo download RCP|Dettaglio forma e dosaggio"
        >Riassunto Caratteristiche Prodotto</span
        >
      </button>

      <p>I medicinali di importazione parallela sono farmaci, registrati e regolarmente in commercio in uno Stato della
        Unione Europea per i quali l'AIFA, su richiesta dell'importatore, qualora esista un medicinale analogo sul
        mercato italiano, autorizza l'importazione nel nostro Paese.</p>

      <p>Il medicinale di "importazione parallela" ha gli stessi effetti terapeutici e la stessa sicurezza d'uso del
        corrispondente medicinale autorizzato in Italia: relativamente a questi aspetti, il Riassunto delle
        Caratteristiche del Prodotto (RCP) consultabile per il medicinale di importazione parallela è quello del
        medicinale autorizzato in Italia.</p>

      <p>Il Foglio illustrativo (FI) del medicinale di importazione parallela potrebbe differire da quello del
        corrispondente medicinale autorizzato in Italia per le informazioni relative al titolare dell'AIC, al
        produttore, nonché in alcuni casi anche relativamente alla denominazione del medicinale, alla composizione in
        eccipienti e alle relative avvertenze, e alle condizioni di conservazione del medicinale.</p>

      <p>Si invitano gli utilizzatori a far riferimento per le informazioni puntuali sul medicinale di importazione al
        foglio illustrativo presente all'interno delle confezioni e alle relative informazioni riportate sul
        confezionamento.</p>
    </div>
  </modal>
  <!-- Fine Modale -->
</div>
